<div *ngFor="let notification of notifications; trackBy: trackByNotificationId"
  class="bo-feedback bo-banner" [ngClass]="getBannerClass(notification.level)" [@slideInOut] [@.disabled]="reduceMotion">
  <span class="bo-feedback__icon" aria-hidden="true"><i [ngClass]="getBannerIcon(notification.level, notification.banner_type)"></i></span>
  <div class="bo-banner__copy" [attr.role]="notification.level === 'ERROR' ? 'alert' : 'status'" aria-atomic="true">
    <div class="bo-banner__title">{{ getBannerTitle(notification) | translate }}</div>
    <p class="bo-banner__message">{{ getBannerMessage(notification) | translate:getBannerMessageParams(notification) }}</p>
  </div>
  <button *ngIf="shouldShowActionButton(notification)" type="button" class="bo-banner__action" (click)="onActionClick(notification)">
    {{ getBannerActionText(notification) | translate }}
    <i class="bi bi-arrow-right" aria-hidden="true"></i>
  </button>
  <button type="button" class="bo-feedback__close" (click)="dismissNotification(notification.id!)" [attr.aria-label]="'ac_close' | translate">
    <i class="bi bi-x" aria-hidden="true"></i>
  </button>
</div>
